import React from "react";

const Footer: React.FC = () => {
  return (
    <section className="bg-transparent p-4 text-sm text-center">
      <p className="text-black text-sm">Standby Travel.© 2025</p>
    </section>
  );
};

export default Footer;
